import React from 'react';
import LicenseMultiSelectField from '../LicenseMultiSelectField';
/**
 * State / Province picker for the three license editors. Jurisdictions are a flat
 * list and all selectable, so unlike Trade this passes no `nonSelectableValues`.
 */
function StateMultiSelectField({ name, label, initialValue = [], options, emptyHint }) {
    return (React.createElement(LicenseMultiSelectField, { name: name, label: label, initialValue: initialValue, options: options, emptyHint: emptyHint, className: "license-state-select-field" }));
}
export default StateMultiSelectField;
